import { FC, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router";
import HomePage from './react/HomePage';
import { ErrorBoundary } from './react/ErrorBoundary';

const MultiScreenPage = lazy(() => import('./react/MultiScreenPage'));
const JoinPage = lazy(() => import('./react/GamePage'));
const TestPage = lazy(() => import('./react/TestPage'));
const InspectorPage = lazy(() => import('./react/InspectPage'));

const App: FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/play/:tableId" element={<JoinPage />} />
            <Route path="/tools/demo" element={<MultiScreenPage />} />
            <Route path="/tools/inspect" element={<InspectorPage />} />
            <Route path="/tools/inspect/:tableId" element={<InspectorPage />} />
            <Route path="/tools/test" element={<TestPage />} />
            <Route path="/*" element={<HomePage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App;
